import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FinanceRoutingModule } from './finance-routing.module';
import { NgProgressModule } from 'ngx-progressbar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2CompleterModule } from 'ng2-completer';
import { FinanceComponent } from './finance.component';
import { SharedModule } from '../shared/shared.module';
import { FinanceDetailsComponent } from './finance-details/finance-details.component';
import { BorrowerDetailsComponent } from './borrower-details/borrower-details.component';
import { FinancialSummaryComponent } from './financial-summary/financial-summary.component';
import { ChildHeaderModule } from '../child-header/child-header.module';
import { HttpClientModule } from '@angular/common/http';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { BreadcrumbModule } from '../breadcrumb/breadcumb.module';

@NgModule({
  imports: [
    CommonModule
    , FinanceRoutingModule
    , HttpClientModule
    , NgProgressModule
    , FormsModule
    , ReactiveFormsModule
    , NgbModule
    , Ng2CompleterModule
    , MatAutocompleteModule
    , MatFormFieldModule
    , MatTableModule
    , MatInputModule
    , SharedModule
    , MatDividerModule
    , MatCardModule
    , MatIconModule
    , MatSelectModule
    , MatCheckboxModule
    , MatDialogModule
    , MatSlideToggleModule
    , MatSortModule
    , MatRadioModule,
    ChildHeaderModule,
    BreadcrumbModule
  ],
  declarations: [FinanceComponent, FinanceDetailsComponent, BorrowerDetailsComponent, FinancialSummaryComponent],
  exports: [FinanceComponent, FinanceDetailsComponent]
})
export class FinanceModule { }
